import {
  GETALL_SETTINGS,
  LOADING_GETALL_SETTINGS,
  ACTIVO_SETTINGS,
  SET_LOGOUT,
  CLEAR_ALL,
  PARAMS_SETTINGS,
} from '../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_SETTINGS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_SETTINGS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_SETTINGS:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_SETTINGS:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
